import React from "react";
import ReactDOM from "react-dom";
import { Switch, Route, BrowserRouter } from "react-router-dom";

import ForgotPassword from "./ForgotPassword";
import Landing from "../landing/Landing";
import AuthEntry from "./AuthEntry";
import Verify2FA from "./Verify2FA";
import ResetPassword from "./ResetPassword";

// Only render if the element exists
const mountNode = document.getElementById("react-landing-root");

if (mountNode) {
    ReactDOM.render(
        <BrowserRouter>
            <Switch>
                <Route path="/Account/Login" component={AuthEntry} />
                <Route
                    path="/Account/ForgotPassword"
                    component={ForgotPassword}
                />
                <Route
                    path="/Account/ResetPassword"
                    component={ResetPassword}
                />
                <Route path="/Account/Verify2FA" component={Verify2FA} />
                <Route exact path="/" component={Landing} />
            </Switch>
        </BrowserRouter>,
        mountNode
    );
}
